import * as fromAuth from "../actions/auth.actions";
import { AuthToken } from "../../shared/interfaces/auth-token";
import { ErrorListing } from "src/app/shared/types/error-listing";

export interface AuthState {
  authToken: AuthToken;
  loginFailed: boolean;
  loginErrors: ErrorListing;
  readTokenFailed: boolean;
  terms: boolean | null;
  termsFailed: ErrorListing;
}

export const initialState: AuthState = {
  authToken: {},
  loginFailed: false,
  loginErrors: {},
  readTokenFailed: false,
  terms: null,
  termsFailed: {},
};

export function reducer(
  state = initialState,
  action: fromAuth.AuthActions,
): AuthState {
  switch (action.type) {
    case fromAuth.LOGIN_COMPLETED: {
      return {
        ...state,
        authToken: (<fromAuth.LoginCompleted>action).payload.authToken,
        loginFailed: false,
        readTokenFailed: false,
      };
    }

    case fromAuth.LOGIN_FAILED: {
      return {
        ...state,
        loginFailed: true,
        loginErrors: action.payload,
      };
    }

    case fromAuth.LOGOUT: {
      return initialState;
    }

    case fromAuth.READ_TOKEN: {
      return {
        ...state,
        readTokenFailed: false,
      };
    }

    case fromAuth.READ_TOKEN_FAILED: {
      return {
        ...state,
        readTokenFailed: true,
      };
    }

    case fromAuth.REFRESH_TOKEN_COMPLETED: {
      return {
        ...state,
        authToken: {
          ...state.authToken,
          access: (<fromAuth.RefreshTokenCompleted>action).payload,
        },
      };
    }

    case fromAuth.TERMS: {
      return {
        ...state,
        terms: null,
      };
    }

    case fromAuth.TERMS_SUCCESS: {
      return {
        ...state,
      };
    }

    case fromAuth.TERMS_FAILED: {
      return {
        ...state,
        termsFailed: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
